const convertToText = (lexicalObject) => {
  if (!lexicalObject || !lexicalObject.root || !lexicalObject.root.children) {
    return '';
  }

  function convertNode(node) {
    if (node.type === 'text') {
      return node.text || '';
    }
    if (node.children && Array.isArray(node.children)) {
      return node.children.map(convertNode).join('');
    }
    return '';
  }

  return lexicalObject.root.children.map(convertNode).join('\n').trim();
};

export { convertToText };
